class UIConstant {
    static ALLOW_MANAGED_SEAT = "1";
    static ALLOW_ADD_DELETE_EDIT_USER = "2";
    static ALLOW_ADD_DELETE_EDIT_ACCOUNT_SETTINGS = "3";
    static ALLOW_MANAGE_OTHER_ADMIN = "4";
    static ALLOW_ADD_DELETE_EDIT_PERMISSION_ROLES = "7";
    static ALLOW_ACCESS_BILLING = "8";
    static DEFAULT_PAGINATION = 50;
    static ZTP_ALLOWED_DEVICES = ["Polycom","Yealink","Cisco"];
    static UNSUPPORTED_DEVICE_MODELS  = ['Cisco SPA 112 ATA','Cisco SPA 122 ATA','Grandstream ATA-16','Grandstream ATA-24','Grandstream ATA-32','Grandstream ATA-48'];
    static BILLING_DETAILS= ["name", "type"];
    static BILLING_USERS = ["name", "extension"];
    static USERS_AND_PHNUMBERS = ["name", "userph", "actualNumber"];
    static LOCATION_DEVICES = ["phone_name","user", "extension", "designation", "model", "mac_address"];
    static LOCATION_NINEONE_DEVICES = ["phone_name", "user", "extension", "designation", "model", "mac_address" ];
    static ROLE_USERS = ["name", "email"];
    static USERS_AND_TEAMS = ["user", "email", "role"];
    static MGROUPS = ["usergroup_name", "user"];
    static ORGANIZATION_POOLS = ["pool_name", "org_name" ];
    static ORG_LANDING = ["org_name", "orgPool"];
    static ROLES_AND_PERMISSION = ["name", "description", "users"];
    static STEAMS_TEAMS =  ["team_name", "team_type"];
    static USER_GROUPS = ["name", "type", "usercount"];
    static USER_LOCATION = ["name", "Address", "user"];
    static ACCOUNT_CONTACTS = ["name", "email", "contact", "mobile", "home", "Office", "owner", "actualNumber", "actualNumberOne", "actualNumberTwo", 'mobile_phone', 'home_phone', 'office_phone'];
    static CORPORATE_CONTACTS = ["name", "email", "extension", "personaldid", "groupname", "actualNumber", "phnumber"];
    static CONTCAT_CUSTOM_FIELD =  ["name", "type"];
    static LOCATION_LANDING =  ['name', 'Address', 'contact', 'number', 'user', 'Devices', "actualNumber", 'phoneNum'];
    static POOL_EDIT = ["phnumber","state","assignedto","assignedname", "location_name", "actualData"];
    static BILLING_LANDING = ["group", "groupType"];
    static OFFICE_LANDING =  ['name', 'Address', 'contact', 'number', 'Devices', 'user', "actualNumber",'phoneNum'];
    static NINEONE_LANDING =  ['name', 'Address', 'contact', 'number', 'Devices', 'user', "actualNumber", 'phoneNum'];
    static TRUSTEDIP_LANDING = ["name", "addedon"];
    static AA_DIAL_BY_NAME_EDITUSER = ['name', 'extension'];
    static HUNT_SUPERVISOR_BODY =  ['name', 'extension'];
    static ASSIGN_PHONE_NUMBER = ['phnumber', 'state', 'assignedto', 'assignedname', 'location_name', 'actualNumber','number'];
    static HUNT_GROUPS = ['name', 'extension', 'phnumber', 'location', 'actualNumber','number'];
    static SMS_GROUPS =  ['name', 'primary_number', 'location', 'actualNumber', 'number'];
    static SMS_GROUP_USERS = ['name', 'email', 'agentid', 'extension'];
    static TN_PORTING_VALIDATION_STATUS = ['order_id', 'status', 'order_type', 'created_date', 'completed_date'];
    static UN_ASSIGN_PHONE_NUMBER = ['phnumber', 'state', 'location_name', 'actualNumber', 'number'];
    static VALIDATE_PHONE_NUMBERS =  ['phnumber', 'assignedname','actualNumber', 'number'];
    static ACC_PHONE_NUMBERS = ['name', 'extension', 'type', 'location'];
    static AUTO_ATTENDANT =  ['name', 'extension', 'number', 'location', 'actualNumber', 'number'];
    static FAX_GROUP_USERS = ['name', 'email', 'extension', 'privilege'];
    static CALL_BLOCKING_BLACK_LIST = ['ph_number', 'comment', 'created_date', 'actualNumber',"phonenumber"];
    static CALL_BLOCKING_WHITE_LIST =['ph_number', 'comment', 'created_date','actualNumber','phonenumber'];
    static CALL_FLOW_LANDING = ['name', 'extension', 'number', 'location_name', 'anumber', 'actualNumber'];
    static DIALBY_NAME_DIRECTORIES =  ['name', 'type'];
    static FAX_GROUP_LANDINGPAGE = ['name', 'primary', 'location', 'actualNumber', 'number'];
    static LUNA_LANDING = ['name', 'extension', 'number', 'voice_type', 'location_name', 'actualNumber','phNumber'];
    static PAGINGGROUPS_FIELDS = ['groupname', 'groupno'];
    static BLFGROUPS_FIELDS = ['blfGroup'];
    static ASSIGNLIST_FIELDS = ['PhoneName','User','Extension','Designation','Location','Model','MacAddress'];
    static UNASSIGNLIST_FIELDS = ['Model','MacAddress'];
    static ONLINELIST_FIELDS = ['phonename', 'user','designation', 'location', 'modelText', 'ipAdress', 'registeredipText', 'registerTo', 'transport', 'software'];
    static STREAMS_API_APP_FIELDS = ['appname']
    static REPUTATION =['number','services','addedOn', 'lastFlagged', 'actualNum', 'actualNumber']
    static REPUTATION_SETTINGS = ['service','violationDate','alert']
    static SMS_CAMPAIGNS = [ 'campaignName', 'brandid', 'campaignID', 'campaignStatusText', 'useCase', 'verticalType', 'registeredOn', 'campaignDescription' ];
    static CAMPAIGNDRAFT = ['brandname', 'campaignname', 'added_on']
    static SMSBRAND = ['name','brandid','statusText']
    static USER_STREAMS_TEAMS = ['username','emailId','role'];
    static DECT_MODELS = ['Yealink W70B','Yealink W60B','Yealink W52P','Cisco ATA-191','Yealink W56P','Yealink W60P']
    static CISCO_DECT_MODELS = ['Cisco ATA-191']
    static STREAMS_API_APP_FIELDS = ['appname']
    static MAX__CONSECUTIVE_NUMBERS = "50"


    // luna and media library max char limit for TTS
    static MAX_CHAR_LUNA = 500;
    static MAX_CHAR_MEDIA = 4096;
    static MAX_CHAR_MEDIA_HUNT = 500;
    static max_brand_proof_pdfcount = 5
    static max_brand_proof_pdfsize  = 1
     static WEBHOOKURLkEYS = {"CTC": "CTC","Inbound_SMS": "IBSMS","Inbound_FAX": "IBFAX","Outbound_SMS":"OBSMS" };

     static CampaignStatus = ['DCA Election Pending', 'CNP Declined', 'Expired']
    static ACDQUEUEDETAILS = ['name', 'extension', 'phnumber', 'location', 'actualNumber']
    static USERDETAILS = ['username', 'extension', 'email', 'service', 'location_name', 'roles']
    static VM_LANDINGPAGE = ['name', 'extension', 'pin']
    static VM_SETTINGS_USERS = ['name', 'extension']
    static MAP_API_KEY = "?key=cb1_3ydv_1_a5292301d3902ca4614f6274"

}
export default UIConstant;